module.exports = __webpack_public_path__ + "img/official-website_odd.cbc941fa.svg";